module.exports = __webpack_public_path__ + "imgs/ww-leaf.fee9258d0351b5f3dd283bed0bf88ccc.jpg";